export const appConstants = {
  ACCEPTED_FILE_FORMATS_FILES:
    '.c,.cs,.cpp,.doc,.docx,.html,.java,.json,.md,.pdf,.php,.pptx,.py,.rb,.tex,.txt,.css,.js,.sh,.ts'.split(',').sort((a, b) => a.localeCompare(b)).join(','),
  ACCEPTED_FILE_FORMATS_CODE_INTERPRETERS:
    '.c,.cs,.cpp,.doc,.docx,.html,.java,.json,.md,.pdf,.php,.pptx,.py,.rb,.tex,.txt,.css,.js,.sh,.ts,.csv,.jpeg,.jpg,.gif,.png,.tar,.xlsx,.xml,.zip'.split(',').sort((a, b) => a.localeCompare(b)).join(','),
}
